import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from '../../../common';
import { RootState } from '../../../reducers';
import { SecurityList } from './components/list';
import { selectParameters, selectSecurityList } from './store/selectors';
import { securityListSlice } from './store/slice';
import { downloadSecurities, fetchSecurityList, SecurityListActionTypes } from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  parameters: selectParameters(state),
  securityList: selectSecurityList(state),
  securityListProgress: progressSelectorFactory([SecurityListActionTypes.FetchSecuritylList])(state),
});

const mapDispatchToProps = {
  ...securityListSlice.actions,
  fetchSecurityList,
  downloadSecurities,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const SecurityListStateContainer = connect(mapStateToProps, mapDispatchToProps)(SecurityList);
